/* Aden Salt — FAQ accordion. Verbatim from the original custom-code block (section-scripts-b.js, last IIFE).
   Progressive enhancement of <details>/<summary> in section#faq; adds .fq-js to the section, runs exclusivity
   itself and animates height. No endpoint or WordPress-specific changes were required. */
/* ---------- FAQ accordion ---------- */
(function(){
  /* S7 FAQ: progressive enhancement of the native details accordion.
     Without JS the rows still open and close (and the name attribute keeps one open at a time).
     With JS: interruptible height animation (280ms, page ease), one row open at a time. */
  var root = document.getElementById('faq');
  if(!root || !root.animate) return;
  var items = Array.prototype.slice.call(root.querySelectorAll('.fq-item'));
  if(!items.length) return;
  var EASE = 'cubic-bezier(0.23,1,0.32,1)';
  var DUR = 280;
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function reduced(){ return !!(mq && mq.matches); }
  root.classList.add('fq-js');
  items.forEach(function(item){
    /* JS runs the exclusivity itself so closing rows can animate */
    item.removeAttribute('name');
    item._fqOpen = item.open;
    item.classList.toggle('is-open', item.open);
  });
  function settle(item){
    var panel = item.querySelector('.fq-a');
    var inner = item.querySelector('.fq-a-in');
    if(item._fqH){ item._fqH.cancel(); item._fqH = null; }
    if(item._fqO){ item._fqO.cancel(); item._fqO = null; }
    panel.style.height = '';
    inner.style.opacity = '';
    item.open = item._fqOpen;
  }
  function setOpen(item, open){
    if(item._fqOpen === open && !item._fqH) return;
    var panel = item.querySelector('.fq-a');
    var inner = item.querySelector('.fq-a-in');
    /* Read where the panel is right now (mid-animation included) before cancelling */
    var startH = item.open ? panel.getBoundingClientRect().height : 0;
    var startO = item.open ? parseFloat(window.getComputedStyle(inner).opacity) : 0;
    if(item._fqH){ item._fqH.cancel(); item._fqH = null; }
    if(item._fqO){ item._fqO.cancel(); item._fqO = null; }
    item._fqOpen = open;
    item.classList.toggle('is-open', open);
    if(reduced()){
      panel.style.height = '';
      item.open = open;
      return;
    }
    item.open = true;
    panel.style.height = '';
    var endH = open ? panel.getBoundingClientRect().height : 0;
    var h = panel.animate([{height:startH + 'px'}, {height:endH + 'px'}], {duration:DUR, easing:EASE});
    var o = inner.animate(
      open ? [{opacity:startO, transform:'translateY(-4px)'}, {opacity:1, transform:'translateY(0)'}]
           : [{opacity:startO}, {opacity:0}],
      {duration:open ? DUR : 180, easing:EASE, fill:'forwards'}
    );
    item._fqH = h;
    item._fqO = o;
    h.onfinish = function(){
      if(item._fqH !== h) return;
      settle(item);
    };
  }
  items.forEach(function(item){
    var summary = item.querySelector('.fq-q');
    summary.addEventListener('click', function(e){
      e.preventDefault();
      var next = !item._fqOpen;
      if(next){
        items.forEach(function(other){
          if(other !== item && other._fqOpen) setOpen(other, false);
        });
      }
      setOpen(item, next);
    });
    /* Keep state honest if the browser opens a row itself (find in page, anchor match) */
    item.addEventListener('toggle', function(){
      if(item._fqH) return;
      if(item.open !== item._fqOpen){
        /* still one row open at a time: close the others first */
        if(item.open){
          items.forEach(function(other){
            if(other !== item && other._fqOpen) setOpen(other, false);
          });
        }
        item._fqOpen = item.open;
        item.classList.toggle('is-open', item.open);
      }
    });
  });
})();
